import '../scss/styles.scss';
import Logo from "../images/sphere.svg";
import handleMenus from "./ScrollToSection"

export default function Header() {
	const handleMenu = () => {
		let menu = document.querySelector( '.mobile-menu' );
		return menu.classList.toggle( 'active' );
	};

	return (
		<section className="header">
			<div className="header-wrapper">
				<ul>
					<li className="logo-container">
						<a href="#home" onClick={handleMenus}>
							<img className="logo-img" src={Logo} alt="Logo" />
							<div className="logo-text-wrapper">
								<p className="logo">Faraway Sound</p>
								<p className="logo">Productions<span>, LLC</span></p>
								<p className="tagline">Audio - Visual - Information Technology</p>
							</div>
						</a>
					</li>
					<li className="icons-container">
						<a className="email-btn"
							href="mailto: jwhite@farawaysoundproductions.com"
							rel="noopener noreferrer"
						></a>
						<a className="call-btn"
							href="tel:4062417299"
							target="_blank"
							rel="noopener noreferrer"
						></a>
						<a className="menu-btn" onClick={handleMenu}>
							<span></span>
							<span></span>
							<span></span>
						</a>
					</li>
					<li className="book-now-container">
						<a className="book-now-btn"
							href="#book-now"
							onClick={handleMenus}>Book Now</a>
					</li>
				</ul>
			</div>
			<div className="menu-wrapper">
				<ul>
					<li><a href="#home" onClick={handleMenus}>Home</a></li>
					<li><a href="#services" onClick={handleMenus}>Services</a></li>
					<li><a href="#inquire" onClick={handleMenus}>Equipment</a></li>
					<li><a href="#about" onClick={handleMenus}>About</a></li>
					<li><a href="#contact" onClick={handleMenus}>Contact</a></li>
				</ul>
			</div>
		</section>
	)
}

